import axios from "axios";
import Config from "../../Config";

const getHeaders = () => ({
  headers: {
    "Content-Type": "application/json",
    Accept: "application/json",
    Authorization: `Bearer ${localStorage.getItem("auth_token")}`,
  },
});

const buildErrorMessage = (error, fallback) =>
  error?.response?.data?.data?.reason ||
  error?.response?.data?.message ||
  error?.message ||
  fallback;

export class OrdersService {
  static async getOrders(params = {}) {
    try {
      const cleanParams = Object.fromEntries(
        Object.entries(params).filter(([, value]) => value !== undefined && value !== null && value !== "")
      );

      const response = await axios.get(`${Config.baseUrl}/orders`, {
        ...getHeaders(),
        params: cleanParams,
      });

      return { success: true, data: response.data?.data };
    } catch (error) {
      return {
        success: false,
        message: buildErrorMessage(error, "Failed to fetch orders"),
      };
    }
  }

  static async getOrderDetails(orderCode) {
    try {
      const response = await axios.get(`${Config.baseUrl}/orders/${orderCode}`, getHeaders());
      return { success: true, data: response.data?.data };
    } catch (error) {
      return {
        success: false,
        message: buildErrorMessage(error, "Failed to fetch order details"),
      };
    }
  }

  static async updateOrderStatus(orderCode, status) {
    try {
      const response = await axios.post(
        `${Config.baseUrl}/orders/${orderCode}/status`,
        { status },
        getHeaders()
      );
      return { success: true, data: response.data?.data };
    } catch (error) {
      return {
        success: false,
        message: buildErrorMessage(error, "Failed to update order status"),
      };
    }
  }
}

export default OrdersService;
